export default "__VITE_ASSET__Bz_vN6b3__"